<main class="monitoring-page">
  <header class="monitoring-header">
    <div>
      <span class="monitoring-kicker">{{t('systemMonitoring.kicker', 'Systemstatus')}}</span>
      <h1>{{t('systemMonitoring.title', 'Plattform-Verfügbarkeit')}}</h1>
      <p>{{t('systemMonitoring.description', 'Überblick über Verfügbarkeit und Stabilität der Plattform.')}}</p>
    </div>
    <div class="monitoring-actions">
      <button mat-button class="secondary-gray-button" (click)="returnToPlatform()"><mat-icon>arrow_back</mat-icon> {{t('systemMonitoring.backToPlatform', 'Zur Plattform')}}</button>
      <button mat-button class="secondary-gray-button" [disabled]="!availability" (click)="printPdfReport()"><mat-icon>picture_as_pdf</mat-icon> PDF</button>
    </div>
  </header>

  <section class="monitoring-toolbar" aria-label="Monitoring Filter">
    <mat-form-field appearance="outline">
      <mat-label>{{t('systemMonitoring.month', 'Monat')}}</mat-label>
      <mat-select [(ngModel)]="selectedMonth" (selectionChange)="loadAvailability()">
        @for (month of availableMonths; track month) {
          <mat-option [value]="month">{{monthLabel(month)}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>

  @if (loading) {
    <section class="monitoring-state"><mat-spinner diameter="32"></mat-spinner><span>{{t('systemMonitoring.loading', 'Verfügbarkeitsdaten werden geladen...')}}</span></section>
  } @else if (error) {
    <section class="monitoring-state error"><mat-icon>error_outline</mat-icon><span>{{error}}</span><button mat-button class="secondary-gray-button" (click)="loadAvailability()">{{t('systemMonitoring.retry', 'Erneut versuchen')}}</button></section>
  } @else if (availability) {
    <section class="availability-summary" aria-label="Verfügbarkeitsübersicht">
      <article class="summary-item primary"><span>{{t('systemMonitoring.availability', 'Verfügbarkeit')}}</span><strong>{{formatPercent(displayedAvailability)}}</strong><small>{{periodLabel}}</small></article>
      <article class="summary-item"><span>{{t('systemMonitoring.target', 'Zielwert')}}</span><strong>{{formatPercent(availability.targetPercent)}}</strong><small>{{t('systemMonitoring.targetDescription', 'Vorgegebener Zielwert')}}</small></article>
      <article class="summary-item" [class.success]="meetsSelectedTarget" [class.warning]="!meetsSelectedTarget"><span>{{t('systemMonitoring.status', 'Status')}}</span><strong>{{meetsSelectedTarget ? t('systemMonitoring.targetMet', 'Ziel erreicht') : t('systemMonitoring.targetMissed', 'Ziel verfehlt')}}</strong></article>
    </section>

    <section class="chart-panel">
      <div class="chart-panel-heading">
        <div><h2>{{t('systemMonitoring.availabilityOverview', 'Verfügbarkeitsübersicht')}}</h2><p>{{t('systemMonitoring.availabilityOverviewDescription', 'Verfügbarkeit im ausgewählten Monat im Vergleich zum Zielwert.')}}</p></div>
        <span class="measured-at">{{t('systemMonitoring.measuredAt', 'Gemessen')}}: {{availability.measuredAt | date:'medium'}}</span>
      </div>
      <ag-charts [options]="chartOptions"></ag-charts>
    </section>

    <p class="availability-statement">{{t('systemMonitoring.statementPrefix', 'Die Plattform-Verfügbarkeit im')}} {{periodLabel}} {{t('systemMonitoring.statementSuffix', 'betrug')}} <strong>{{formatPercent(displayedAvailability)}}</strong>.</p>
  }
</main>
